import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setNodesActionCreator } from '../node/nodeSlice';
import { setEdgesActionCreator } from '../edge/edgeSlice';
import { replaceTemplateSettings } from '../view/viewSlice';

const cloneSnapshot = (snapshot) => {
  if (!snapshot) return null;
  return JSON.parse(JSON.stringify(snapshot));
};
  
export const performUndo = createAsyncThunk(
  'history/performUndo',
  async (_, { getState, dispatch }) => {
    const { past, present, future } = getState().history;
    if (past.length > 0) {
      const previous = past[past.length - 1];
      dispatch(setNodesActionCreator({ nodes: previous.nodes, replace: true }));
      dispatch(setEdgesActionCreator({ edges: previous.edges }));
      dispatch(replaceTemplateSettings(previous?.templateSettings));
      return { past: past.slice(0, -1), present: previous, future: [present, ...future] };
    }
  }
);

export const performRedo = createAsyncThunk(
  'history/performRedo',
  async (_, { getState, dispatch }) => {
    const { past, present, future } = getState().history;
    if (future.length > 0) {
      const next = future[0];
      dispatch(setNodesActionCreator({ nodes: next.nodes, replace: true }));
      dispatch(setEdgesActionCreator({ edges: next.edges }));
      dispatch(replaceTemplateSettings(next?.templateSettings));
      return { past: [...past, present], present: next, future: future.slice(1) };
    }
  }
);

  const initialState = {
    past: [],
    present: null,
    future: [],
    applying: false,
  };
  
  export const historySlice = createSlice({
    name: 'history',
    initialState,
    reducers: {
      addHistoryState: (state, action) => {
        const nextSnapshot = action.payload;
        if (!nextSnapshot) {
          return;
        }
        if (state.present) {
          state.past.push(state.present);
        }
        state.present = nextSnapshot;
        state.future = [];
      },
      setHistoryBaseline: (state, action) => {
        state.past = [];
        state.present = cloneSnapshot(action.payload);
        state.future = [];
        state.applying = false;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(performUndo.pending, (state) => {
          state.applying = true;
        })
        .addCase(performUndo.fulfilled, (state, action) => {
          if (!action.payload) {
            state.applying = false;
            return;
          }
          const { past, present, future } = action.payload;
          state.past = past;
          state.present = present;
          state.future = future;
          state.applying = false;
        })
        .addCase(performRedo.pending, (state) => {
          state.applying = true;
        })
        .addCase(performRedo.fulfilled, (state, action) => {
          if (!action.payload) {
            state.applying = false;
            return;
          }
          const { past, present, future } = action.payload;
          state.past = past;
          state.present = present;
          state.future = future;
          state.applying = false;
        });
    }
  });
  
export const { addHistoryState, setHistoryBaseline } = historySlice.actions;
export default historySlice.reducer;
